// 引入组件
// 01.Router 引入路由组件
import Vue from 'vue'
import Router from 'vue-router'
// 02.Store 引入状态管理
import Store from '../store/index'

Vue.use(Router)

// 02.路由路径数组
let routes = [
    // 02.01.无后缀跳转到系统首页
    {
        path: '',
        redirect: '/index'
    },
    {
        path: "/index",
        name: "山西省临汾工商行政管理学校",
        component: () => import("../components/service/index.vue"),
        meta: {
            keepAlive: true,
            title: "主页"
        }
    },
    {
        path: "/content/:id",
        name: "山西省临汾工商行政管理学校",
        component: () => import("../components/service/content.vue"),
        meta: {
            keepAlive: true,
            title: "内容页"
        }
    },
    {
        path: "/tszjj",
        name: "山西省临汾工商行政管理学校 - /tszjj",
        component: () => import("../components/service/list.vue"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校"
        }
    },
    {
        path: "/pxjj",
        name: "山西省临汾工商行政管理学校 - pxjj",
        component: () => import("../components/service/list.vue"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校"
        }
    },
    {
        path: "/xywh",
        name: "山西省临汾工商行政管理学校 - xywh",
        component: () => import("../components/service/list.vue"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校"
        }
    },
    {
        path: "/djyd",
        name: "山西省临汾工商行政管理学校 - djyd",
        component: () => import("../components/service/list.vue"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校"
        }
    },
    {
        path: "/zsjy",
        name: "山西省临汾工商行政管理学校 - zsjy",
        component: () => import("../components/service/list.vue"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校"
        }
    },
    {
        path: "/xxjj",
        name: "山西省临汾工商行政管理学校 - xxjj",
        component: () => import("../components/service/list.vue"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校"
        }
    },
    {
        path: "/jgsz",
        name: "山西省临汾工商行政管理学校 - jgsz",
        component: () => import("../components/service/list.vue"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校"
        }
    },
    {
        path: "/szjs",
        name: "山西省临汾工商行政管理学校 - szjs",
        component: () => import("../components/service/list.vue"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校"
        }
    },
    {
        path: "/xxyw",
        name: "山西省临汾工商行政管理学校 - xxyw",
        component: () => import("../components/service/list.vue"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校"
        }
    },
    {
        path: "/llxx",
        name: "山西省临汾工商行政管理学校 -llxx",
        component: () => import("../components/service/list.vue"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校"
        }
    },
    {
        path: "/djdt",
        name: "山西省临汾工商行政管理学校 -djdt",
        component: () => import("../components/service/list.vue"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校"
        }
    },
    {
        path: "/xyfc",
        name: "山西省临汾工商行政管理学校 -xyfc",
        component: () => import("../components/service/list.vue"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校"
        }
    },
    {
        path: "/szjj",
        name: "山西省临汾工商行政管理学校 -szjj",
        component: () => import("../components/service/list.vue"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校"
        }
    },
    {
        path: "/zsjj",
        name: "山西省临汾工商行政管理学校 -zsjj",
        component: () => import("../components/service/list.vue"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校"
        }
    },
    {
        path: "/jxxx",
        name: "山西省临汾工商行政管理学校 - jxxx",
        component: () => import("../components/service/list.vue"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校"
        }
    },
    {
        path: "/tzgg",
        name: "山西省临汾工商行政管理学校 - tzgg",
        component: () => import("../components/service/list.vue"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校"
        }
    },
    {
        path: "/kfdt",
        name: "山西省临汾工商行政管理学校 - kfdt",
        component: () => import("../components/service/list.vue"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校"
        }
    },
    {
        path: "/pxdt",
        name: "山西省临汾工商行政管理学校 - pxdt",
        component: () => import("../components/service/list.vue"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校"
        }
    },
    {
        path: '/manage/',
        redirect: '/manage/index'
    },
    {
        path: '/manage/index',
        redirect: '/manage/home'
    },
    // 02.02.登录页
    {
        path: "/manage/login",
        name: "山西省临汾工商行政管理学校 - 登录页",
        component: () => import("../components/common/login"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校 - 登录页"
        }
    },
    // 02.03.404页面
    {
        path: '/404',
        name: "404页面",
        component: () => import("../components/common/404"),
        meta: {
            requireAuth: false,
            title: "404页面"
        },
    },
    // 02.04.index页面
    {
        path: "/manage/index",
        name: "山西省临汾工商行政管理学校 - 首页",
        component: () => import("../components/common/index"),
        meta: {
            keepAlive: true,
            title: "山西省临汾工商行政管理学校 - 首页"
        },
        children: [
            // 00.通用 页面 --------------------------------------------------
            // 00.01.系统首页
            {
                path: '/manage/home',
                name: '工作台',
                meta: {
                    keepAlive: true,
                    title: '工作台',
                    description: '对平台的权限相关信息进行删除、审核、导入、导出等系统操作。'
                },
                component: () => import('../components/common/home')
            },
            // 00.01.系统首页
            {
                path: '/manage/user-config',
                name: '用户设置',
                meta: {keepAlive: true, title: '用户设置', description: '对已登录用户的信息、密码、系统进行基础设置。'},
                component: () => import('../components/common/user_config')
            },
            // 01.业务 / 数据 页面 --------------------------------------------------
            // 02.管理 / 配置 页面 --------------------------------------------------
            // 02.01.权限
            {
                path: '/manage/admin/add-power',
                name: '新增权限',
                meta: {keepAlive: true, title: '新增权限', description: '对平台的权限相关信息进行添加。'},
                component: () => import('../components/manage/add_power')
            },
            {
                path: '/manage/admin/patch-power/:id',
                name: '修改权限',
                meta: {keepAlive: true, title: '修改权限', description: '对平台的权限相关信息进行修改。'},
                component: () => import('../components/manage/add_power')
            },
            {
                path: '/manage/admin/data-power',
                name: '权限管理',
                meta: {
                    keepAlive: true,
                    title: '权限管理',
                    description: '对平台的权限相关信息进行删除、审核、导入、导出等系统操作。'
                },
                component: () => import('../components/manage/data_power')
            },
            // 02.02.角色
            {
                path: '/manage/admin/data-role',
                name: '角色管理',
                meta: {
                    keepAlive: true,
                    title: '角色管理',
                    description: '对平台的角色相关信息进行添加、修改、删除、审核、导入、导出等系统操作。'
                },
                component: () => import('../components/manage/data_role')
            },
            // 02.03.管理员
            {
                path: '/manage/admin/add-admin',
                name: '新增管理员',
                meta: {keepAlive: true, title: '新增管理员', description: '对平台的管理员相关信息进行添加。'},
                component: () => import('../components/manage/add_admin')
            },
            {
                path: '/manage/admin/patch-admin/:id',
                name: '修改管理员',
                meta: {keepAlive: true, title: '修改管理员', description: '对平台的管理员相关信息进行修改。'},
                component: () => import('../components/manage/add_admin')
            },
            {
                path: '/manage/admin/data-admin',
                name: '管理员管理',
                meta: {
                    keepAlive: true,
                    title: '管理员管理',
                    description: '对平台的管理员相关信息进行删除、审核、导入、导出等系统操作。'
                },
                component: () => import('../components/manage/data_admin')
            },
            {
                path: '/manage/admin/login-log',
                name: '管理员登录日志',
                meta: {keepAlive: true, title: '管理员登录日志', description: '对平台的管理员登录情况进行日志记录。'},
                component: () => import('../components/manage/log_admin')
            },
            {
                path: '/manage/admin/operation-log',
                name: '管理员操作日志',
                meta: {keepAlive: true, title: '管理员操作日志', description: '对平台的管理员操作情况进行日志记录。'},
                component: () => import('../components/manage/log_operation')
            },
            // 02.04.用户
            {
                path: '/manage/user/add-user',
                name: '新增用户',
                meta: {keepAlive: true, title: '新增用户', description: '对平台的用户相关信息进行添加。'},
                component: () => import('../components/manage/add_user')
            },
            {
                path: '/manage/user/patch-user/:id',
                name: '修改用户',
                meta: {keepAlive: true, title: '修改用户', description: '对平台的用户相关信息进行修改。'},
                component: () => import('../components/manage/add_user')
            },
            {
                path: '/manage/user/data-user',
                name: '用户管理',
                meta: {
                    keepAlive: true,
                    title: '用户管理',
                    description: '对平台的用户相关信息进行删除、审核、导入、导出等系统操作。'
                },
                component: () => import('../components/manage/data_user')
            },
            {
                path: '/manage/user/login-log',
                name: '用户登录日志',
                meta: {keepAlive: true, title: '用户登录日志', description: '对平台的用户登录情况进行日志记录。'},
                component: () => import('../components/manage/log_user')
            },
            // 02.05.系统字典
            {
                path: '/manage/basics/add-basics',
                name: '新增字典',
                meta: {keepAlive: true, title: '新增字典', description: '对平台的字典相关信息进行添加。'},
                component: () => import('../components/manage/add_basics')
            },
            {
                path: '/manage/basics/patch-basics/:id',
                name: '修改字典',
                meta: {keepAlive: true, title: '修改字典', description: '对平台的字典相关信息进行修改。'},
                component: () => import('../components/manage/add_basics')
            },
            {
                path: '/manage/basics/data-basics',
                name: '字典管控',
                meta: {
                    keepAlive: true,
                    title: '字典管控',
                    description: '对平台的字典相关信息进行删除、审核、导入、导出等系统操作。'
                },
                component: () => import('../components/manage/data_basics')
            },


            // 02.02.轮播图
            {
                path: '/manage/data-carousel',
                name: '轮播图',
                meta: {
                    keepAlive: true,
                    title: '轮播图',
                    description: '对平台的轮播图相关信息进行添加、修改、删除、审核、导入、导出等系统操作。'
                },
                component: () => import('../components/manage/data_carousel')
            },
            // 02.02.友情链接
            {
                path: '/manage/data-link',
                name: '友情链接',
                meta: {
                    keepAlive: true,
                    title: '友情链接',
                    description: '对平台的友情链接相关信息进行添加、修改、删除、审核、导入、导出等系统操作。'
                },
                component: () => import('../components/manage/data_link')
            },
            // 02.02.友情链接
            {
                path: '/manage/data-index-img',
                name: '官网首页图片',
                meta: {
                    keepAlive: true,
                    title: '官网首页图片',
                    description: '对官网首页图片相关信息进行添加、修改、删除、审核、导入、导出等系统操作。'
                },
                component: () => import('../components/manage/data_index_img')
            },
            // 02.01.栏目
            {
                path: '/manage/item/add-item',
                name: '新增栏目',
                meta: {keepAlive: true, title: '新增栏目', description: '对平台的栏目相关信息进行添加。'},
                component: () => import('../components/manage/add_item')
            },
            {
                path: '/manage/item/patch-item/:id',
                name: '修改栏目',
                meta: {keepAlive: true, title: '修改栏目', description: '对平台的栏目相关信息进行修改。'},
                component: () => import('../components/manage/add_item')
            },
            {
                path: '/manage/item/data-item',
                name: '栏目管理',
                meta: {
                    keepAlive: true,
                    title: '栏目管理',
                    description: '对平台的栏目相关信息进行删除、审核、导入、导出等系统操作。'
                },
                component: () => import('../components/manage/data_item')
            },
            // 02.01.内容
            {
                path: '/manage/content/add-content',
                name: '新增内容',
                meta: {keepAlive: true, title: '新增内容', description: '对平台的内容相关信息进行添加。'},
                component: () => import('../components/manage/add_content')
            },
            {
                path: '/manage/content/patch-content/:id',
                name: '修改内容',
                meta: {keepAlive: true, title: '修改内容', description: '对平台的内容相关信息进行修改。'},
                component: () => import('../components/manage/add_content')
            },
            {
                path: '/manage/content/data-content',
                name: '内容管理',
                meta: {
                    keepAlive: true,
                    title: '内容管理',
                    description: '对平台的内容相关信息进行删除、审核、导入、导出等系统操作。'
                },
                component: () => import('../components/manage/data_content')
            },


        ]
    },
]

// 03.引入路由路径
const router = new Router({
    mode: 'history',
    base: __dirname,
    routes: routes
})

// 04.设置页面Title并进入页面
router.beforeEach((to, from, next) => {
    // 04.01.设置页面Title
    if (to.meta.title) {
        document.title = to.meta.title
    }
    if (to.path.indexOf("/manage/") < 0) {
        next()
    } else {
        if (to.path === '/manage/login') {
            next()
        } else {
            // 04.02.检测是否获得Token
            if (!localStorage.getItem('Token')) {
                next('/manage/login')
            } else {
                // 04.03.异常页面跳转至404
                if (to.matched.length !== 0) {
                    PathURL(to)
                    next()
                } else {
                    next('/404')
                }
            }
        }
    }
})

// 05.执行Router
export default router

// 06.检测当前URL，并指定相关Tabs Page当前选中页，并跳转URL
function PathURL(to) {
    // 06.01.当前URL是否存在
    if (to.name) {
        // 06.02.不添加至Tabs Page数组
        let forbidURL = ['/manage/login', '/manage/index', '/404']
        // 06.03.是否允许添加Tabs Page数组
        if (forbidURL.indexOf(to.path) === -1) {
            // 06.04.定义Tabs Page临时数组
            let tabs_value = []
            let url_value = []
            // 06.05.获取现有打开Tabs Page页面数组
            for (let data in Store.state.pageOptions) {
                tabs_value.push({
                    "url": Store.state.pageOptions[data].url,
                    "name": Store.state.pageOptions[data].name
                })
                url_value.push(Store.state.pageOptions[data].url)
            }
            // 06.06.判断打开URL现有Tabs Page数组是否存在
            if (url_value.indexOf(to.path) === -1) {
                tabs_value.push({
                    "url": to.path,
                    "name": to.name
                })
                Store.state.pageOptions = tabs_value
                Store.state.pageActive = to.path
                localStorage.setItem("pageOptions", JSON.stringify(tabs_value))
                localStorage.setItem("pageActive", JSON.stringify(to.path))
            } else {
                Store.state.pageActive = to.path
                localStorage.setItem("pageActive", JSON.stringify(to.path))
            }
        }
    }
}
